var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditNote = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9515 11H15.6549C15.4947 11.2675 15.2973 11.513 15.0682 11.73L12.1925 14.475C11.9652 14.6937 11.7079 14.8821 11.4277 15.035V11.5C11.4277 11.3674 11.4829 11.2402 11.5812 11.1464C11.6794 11.0527 11.8126 11 11.9515 11Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1423 3V9.255C16.1434 9.50554 16.1153 9.75542 16.0584 10H11.9518C11.5354 10.0012 11.1364 10.1596 10.842 10.4407C10.5476 10.7217 10.3816 11.1025 10.3803 11.5V15.42C10.1241 15.4743 9.86234 15.5011 9.59987 15.5H3.04701C2.63063 15.4988 2.23165 15.3404 1.93722 15.0593C1.64279 14.7783 1.47683 14.3975 1.47559 14V3C1.47683 2.60254 1.64279 2.2217 1.93722 1.94065C2.23165 1.6596 2.63063 1.50119 3.04701 1.5H14.5708C14.9872 1.50119 15.3862 1.6596 15.6806 1.94065C15.975 2.2217 16.141 2.60254 16.1423 3Z",
    fill: "#141414"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit_note.11f3694a.svg";
export { ForwardRef as ReactComponent };